module.exports = __webpack_public_path__ + "static/media/editor_admin.a19f4b72.svg";